import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'

import { createStyles, makeStyles, Theme } from '../../../themes/ThemeProvider'
import TextField, { TextFieldProps as Props } from '../Input'

type ReactHookFormProps = {
  name: string
  formContext?: any
}

export type FormTextFieldProps = Props & ReactHookFormProps

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginBottom: theme.spacing(2.5)
    },
    MuiFormHelperTextContained: {
      marginLeft: 0,
      position: 'absolute',
      bottom: theme.spacing(-2.5)
    }
  })
)

export const FormTextField: React.FC<FormTextFieldProps> = (props) => {
  const classes = useStyles(props)
  const { name, label, defaultValue, formContext, ...rest } = props
  const formContextLocal = useFormContext()
  const { control, errors } = formContext || formContextLocal

  const formHelperTextProps = {
    classes: {
      contained: classes.MuiFormHelperTextContained
    }
  }

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue ?? ''}
      render={({ onChange, value }) => {
        return (
          <TextField
            fullWidth
            value={value}
            onChange={onChange}
            label={label ? label : undefined}
            placeholder={label ? `Enter ${label}` : undefined}
            helperText={errors[`${name}`]?.message}
            error={!!errors[`${name}`]}
            FormHelperTextProps={formHelperTextProps}
            inputProps={{ 'data-testid': name }}
            className={classes.root}
            {...rest}
          />
        )
      }}
    />
  )
}
